import { Trans } from '@lyearn/i18n';
import { Mobile2Outline, Monitor, TabletOutline } from '@lyearn/icons';

const devicesConfig = [
  {
    id: 'desktop',
    name: <Trans i18nKey="Devices:Desktop" />,
    className: 'device-preview-desktop',
    Icon: <Monitor className="fill-current text-icon-active" />,
  },
  {
    id: 'tablet',
    name: <Trans i18nKey="Devices:TabletPortrait" />,
    className: 'device-preview-tablet',
    Icon: <TabletOutline className="fill-current text-icon-active" />,
  },
  /* {
    id: 'tablet-landscape',
    name: <Trans i18nKey="Devices:TabletLandscape" />,
    className: 'device-preview-tablet  device-preview-landscape',
    Icon: <IconSquare className="text-icon-active fill-current" />,
  }, */
  {
    id: 'mobile',
    name: <Trans i18nKey="Devices:MobilePortrait" />,
    className: 'device-preview-mobile',
    Icon: <Mobile2Outline className="fill-current text-icon-active" />,
  },
  /* {
    id: 'mobile-landscape',
    name: <Trans i18nKey="Devices:MobileLandscape" />,
    className: 'device-preview-mobile  device-preview-landscape',
    Icon: <IconSquare className="text-icon-active fill-current" />,
  }, */
];

export default devicesConfig;
